<script lang="ts" setup>
import { Task, User } from "@/types/v2";
import { defineEmits, defineProps } from "vue";
import { convertStringHumanReadable } from "@/utils/v2";

import ModalBox from "@/components/v2/Modal/ModalBox.vue";

interface TaskStartModalProps {
    show: boolean;
    task: Task;
    currentUser: User | null;
}

const props = defineProps<TaskStartModalProps>();
const emit = defineEmits(["start", "close"]);

const start = () => {
    emit("start", props.task)
};
const close = () => {
    emit("close")
};
</script>

<template>
    <ModalBox v-if="show" @close="close">
        <template #header>
            {{ convertStringHumanReadable(task.objective as string) }}
            <span v-if="task.additionalTitle">({{ task.additionalTitle }})</span>
            <span v-if="task.studyTitle">: {{ task.studyTitle }}</span>
            <span v-if="task.status === 'finished'">- Completed</span>
        </template>

        <template #main>
            <p>{{ task.description }}</p>
        </template>

        <template #footer>
            <button
                v-if="task.status !== 'finished'" class="disabled:opacity-25 text-white bg-primary hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center" type="button"
                @click="start"
            >
                Start
            </button>
            <button
                class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10" type="button"
                @click="close"
            >
                Close
            </button>
        </template>
    </ModalBox>
</template>
